import { useTranslation } from 'react-i18next'
import { Button } from '@arabquiz/ui'
import { Modal } from './Modal'

type ConfirmDialogProps = {
  open: boolean
  title: string
  message: string
  /** Confirm button label; defaults to common `delete`. */
  confirmLabel?: string
  confirmPending?: boolean
  onConfirm: () => void
  onClose: () => void
}

/**
 * Focus-trapped destructive confirmation built on the shared {@link Modal}
 * (Radix dialog), so `Esc`, focus trap and focus restore are handled. Used
 * for deleting bank items and categories.
 */
export function ConfirmDialog({
  open,
  title,
  message,
  confirmLabel,
  confirmPending = false,
  onConfirm,
  onClose,
}: ConfirmDialogProps) {
  const { t } = useTranslation('common')

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={title}
      footer={
        <div className="flex items-center justify-end gap-3">
          <Button type="button" variant="ghost" onClick={onClose}>
            {t('cancel')}
          </Button>
          <Button
            type="button"
            variant="destructive"
            onClick={onConfirm}
            disabled={confirmPending}
          >
            {confirmPending ? t('loading') : (confirmLabel ?? t('delete'))}
          </Button>
        </div>
      }
    >
      <p className="text-sm text-brand-700 leading-relaxed">{message}</p>
    </Modal>
  )
}
